export default __webpack_public_path__ + "static/media/helmetimage.c297fa74.png";